// extracted by mini-css-extract-plugin
module.exports = {"value-input":"value-input-1wfku7r"};